


































































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ADD_LETTER_TEMPLATE } from '../store';
import { letterPlaceholder, Placeholder } from '@/statics/placeholders';
import { WriteLetterTemplate } from '@/modules/correspondence/types';
import { createLetterTemplate } from '@/modules/correspondence/model';
import { ApiResponse } from '@/components/types';
import PlaceholderTable from '../components/PlaceholderTable.vue';
import ReceiverTypeSelect from './ReceiverTypeSelect.vue';
import VisibilitySelect from './VisibilitySelect.vue';
import RichEditor from './RichEditor.vue';

const Correspondence = namespace('correspondence');

@Component({
  components: {
    RichEditor,
    PlaceholderTable,
    VisibilitySelect,
    ReceiverTypeSelect
  }
})
export default class CreateLetterTemplateDialog extends Vue {
  @Correspondence.Action(ADD_LETTER_TEMPLATE) addTemplate!: (letterTemplate: WriteLetterTemplate) => Promise<ApiResponse>;

  error: any = null;
  loading: boolean = false;
  dialog: boolean = false;
  value: WriteLetterTemplate = createLetterTemplate(this.$auth.user().id);

  cancel(observer?: any) {
    setTimeout(() => {
      this.value = createLetterTemplate(this.$auth.user().id);
      this.error = null;
      this.dialog = false;
      observer && observer.reset();
    });
  }

  get placeholders(): Placeholder[] {
    return letterPlaceholder(
      this.value.requirements.includes('conservatorship'),
      this.value.requirements.includes('bank_account')
    );
  }

  async save() {
    this.error = null;

    return this.addTemplate(this.value);
  }
}
